import { BloodOxygen } from "@cur8/health-risks-calc";
import { PathLink } from "@pomle/react-router-paths";
import { paths } from "render/routes/paths";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useBloodOxygenMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Metric, MetricLoading } from "../../layouts/Metric";
import { Trans } from "./trans";

export function MetricBloodOxygen() {
  const { data, isLoading: isDataLoading } = useBloodOxygenMetric();

  if (isDataLoading) {
    return <MetricLoading label={<Trans.MetricName />} />;
  }

  if (!data) {
    return null;
  }

  const { cur, prev } = getMetricHistory(data);
  const riskRanges = BloodOxygen.rangesFor();
  const metricRating = cur && riskRanges.findRisk({ "%": cur.unit.percent });
  const value = cur?.unit.percent;
  const previousVale = prev?.unit.percent;

  return (
    <PathLink to={paths.bloodOxygenMetric.url({})}>
      <Metric
        label={<Trans.MetricName />}
        value={value}
        metricRating={metricRating}
        subLabel={<Trans.MetricUnit />}
        previousValue={previousVale}
        showPreviousInsteadOfChange={true}
      />
    </PathLink>
  );
}
